import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { getConsolidatedPortfolio } from '@repo/position-services'
import { consolidatedPortfolioActions, consolidatedPortfolioDownloadActions } from '../../../slices'

export const consolidatedPortfolioConfig = defineSagaForService({
  [consolidatedPortfolioActions.getRequest.type]: {
    apiClientDomain: 'position',
    service: getConsolidatedPortfolio,
    actionTypeResponse: consolidatedPortfolioActions.getResponse.type,
    actionTypeRequest: consolidatedPortfolioActions.getRequest.type,
  },
  [consolidatedPortfolioActions.refreshRequest.type]: {
    apiClientDomain: 'position',
    service: getConsolidatedPortfolio,
    actionTypeResponse: consolidatedPortfolioActions.refreshResponse.type,
    actionTypeRequest: consolidatedPortfolioActions.refreshRequest.type,
  },
})

export const consolidatedPortfolioDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [consolidatedPortfolioDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'position',
    service: getConsolidatedPortfolio,
    actionTypeRequest: consolidatedPortfolioDownloadActions.downloadRequest.type,
    actionTypeResponse: consolidatedPortfolioDownloadActions.downloadResponse.type,
  },
}
